var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueenBedIconTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic_bed_queen"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M10.6667 3.66659V1.66659C10.6667 0.930206 10.0697 0.333252 9.33333 0.333252H2.66667C1.93029 0.333252 1.33333 0.930206 1.33333 1.66659V3.66659C0.596954 3.66659 0 4.26354 0 4.99992V8.33325H0.886667L1.33333 9.66659H2L2.44667 8.33325H9.55333L10 9.66659H10.6667L11.1133 8.33325H12V4.99992C12 4.26354 11.403 3.66659 10.6667 3.66659ZM9.33333 3.66659H2.66667V1.66659H9.33333V3.66659Z",
    fill: "#2800A0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_2772",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 10
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 3.66659V1.66659C10.6667 0.930206 10.0697 0.333252 9.33333 0.333252H2.66667C1.93029 0.333252 1.33333 0.930206 1.33333 1.66659V3.66659C0.596954 3.66659 0 4.26354 0 4.99992V8.33325H0.886667L1.33333 9.66659H2L2.44667 8.33325H9.55333L10 9.66659H10.6667L11.1133 8.33325H12V4.99992C12 4.26354 11.403 3.66659 10.6667 3.66659ZM9.33333 3.66659H2.66667V1.66659H9.33333V3.66659Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_2772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Black",
    d: "M22.6666 -11.6667H-10.6667V21.6666H22.6666V-11.6667Z",
    fill: "#2800A0"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueenBedIconTransavia);
export default __webpack_public_path__ + "static/media/queen-bed-icon-transavia.3ac18e9e8c1fdb624750388552568c46.svg";
export { ForwardRef as ReactComponent };